var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSwap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.55 18.29",
    style: {
      enableBackground: "new 0 0 20.55 18.29"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#121212;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.27,8.13c-0.55,0-1,0.45-1,1v3c0,1.1-0.9,2-2,2h-11v-1c-0.02-0.17-0.07-0.32-0.16-0.46 c-0.31-0.46-0.93-0.58-1.39-0.28l-3,2l-0.12,0.1c-0.08,0.08-0.14,0.17-0.19,0.27v0.07c-0.09,0.22-0.09,0.47,0,0.69v0.07 c0.05,0.1,0.11,0.19,0.19,0.27l0.12,0.1l3,2c0.16,0.11,0.35,0.16,0.54,0.16c0.55,0,1-0.44,1.01-0.99v-1h11c2.21,0,4-1.79,4-4v-3 C20.27,8.58,19.82,8.13,19.27,8.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.27,10.13c0.55,0,1-0.45,1-1v-3c0-1.1,0.9-2,2-2h11v1c0,0.55,0.45,1,1.01,0.99c0.19,0,0.38-0.06,0.54-0.16 l3-2l0.12-0.1c0.07-0.08,0.14-0.17,0.18-0.27V3.52c0.09-0.22,0.09-0.47,0-0.69V2.76c-0.04-0.1-0.11-0.19-0.18-0.27l-0.12-0.1l-3-2 c-0.46-0.31-1.08-0.18-1.39,0.28c-0.09,0.14-0.15,0.3-0.16,0.46v1h-11c-2.21,0-4,1.79-4,4v3C0.27,9.69,0.72,10.13,1.27,10.13z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/swap.a24581d49edc1c9f4b5c43fe4e92ce80.svg";